///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};
modules.ribit.reporting = modules.ribit.reporting || {};
modules.ribit.reporting.create = modules.ribit.reporting.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit.reporting.index = {
    /**
     *
     */
    init: function () {
        // Auto advance the run timer on the history datatable
        setInterval(function() {
            $('.run_timer').each(function() {
                let startTime = (parseInt($(this).data('starttime')) * 1000) + 1000;
                let elapsedTime = new Date().getTime() - startTime;

                let seconds = Math.floor(elapsedTime / 1000);
                let minutes = Math.floor(seconds / 60);
                let hours = Math.floor(minutes / 60);

                seconds %= 60;
                minutes %= 60;

                $(this).text(
                    modules.ribit.reporting.index.pad(hours) + ":"
                    + modules.ribit.reporting.index.pad(minutes) + ":"
                    + modules.ribit.reporting.index.pad(seconds)
                );
            });
        }, 1000);
    },

    pad: function(number) {
        return (number < 10 ? "0" : "") + number;
    },
};
